import tw from 'twin.macro'

export {
  flowEditorTextInputCss as formFieldInputCss,
  flowEditorTextareaCss as formFieldTextareaCss,
} from '../../flowEditorInputStyles'

export const formFieldInputReadOnlyCss = tw`cursor-not-allowed bg-shades-50 text-shades-500 opacity-[0.85]`

export const formSectionCss = tw`flex flex-col gap-2.5 border-b border-shades-100 px-5 py-3.5 border-solid`

export const formSectionLabelCss = (disabled = false) => [
  tw`text-sm font-semibold`,
  disabled ? tw`text-shades-400` : tw`text-shades-800`,
]

export const formPreviewLabelCss = (disabled = false) => [
  tw`text-sm font-semibold`,
  disabled ? tw`text-shades-400` : tw`text-shades-800`,
]

export const formRequiredMarkCss = tw`text-critical-500`

export const moveBtnCss = (disabled: boolean) => [
  tw`flex h-7 w-7 items-center justify-center rounded-md border-0 bg-transparent transition-colors border-solid`,
  disabled
    ? tw`cursor-not-allowed text-shades-300`
    : tw`cursor-pointer text-shades-500 hover:bg-shades-100 hover:text-shades-900`,
]

export const optionSwapBtnCss = (disabled: boolean) => [
  tw`flex h-[26px] w-[26px] items-center justify-center rounded-md border-0 bg-transparent border-solid`,
  disabled ? tw`cursor-not-allowed text-shades-300` : tw`cursor-pointer text-shades-500`,
]

export const formTabBtnCss = (active: boolean, readOnly: boolean) => [
  tw`h-[42px] flex-1 border-0 text-[13px] transition-all duration-150 border-solid`,
  readOnly ? tw`cursor-not-allowed opacity-[0.55]` : tw`cursor-pointer`,
  active
    ? tw`border-b-2 border-primary-500 bg-primary-50 font-semibold text-primary-700 border-solid`
    : tw`border-b-2 border-transparent bg-transparent font-medium text-shades-500 hover:bg-shades-50 border-solid`,
]
